import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import UploadPrescriptionConfig from "@widgets/UploadPrescription/UploadPrescription.skeleton"
import PrescriptionSelectConfig from "@widgets/PrescriptionSelect/PrescriptionSelect.skeleton"
import LowEmphasisUpsellConfig from "@widgets/LowEmphasisUpsell/LowEmphasisUpsell.skeleton"
import ImagesCarouselConfig from "../../widgets/ImagesCarousel/ImagesCarousel.skeleton"

const ButtonConfig = [{ span: 10, height: "40px", classes: "marginTop-48" }]
const orDivider = [{ span: 12, height: "21px", classes: "marginTop-24" }]
const VerticalDivider = [{ span: 2 }]
const FootnoteConfig = [{ span: 12, height: "48px", classes: "marginTop-32" }]
const SeparatorConfig = [{ span: 10, height: "8px", classes: "marginTop-24" }]

function PrescriptionSkeleton() {
    return (
        <div className="page-container">
            <div className="container-fluid flex">
                <div className="flex-column">
                    <Skeleton config={UploadPrescriptionConfig} isComponent></Skeleton>
                    <Skeleton config={orDivider} isComponent></Skeleton>
                    <Skeleton config={PrescriptionSelectConfig} isComponent></Skeleton>
                    <Skeleton config={FootnoteConfig} isComponent></Skeleton>
                </div>
                <div className="flex-column">
                    <Skeleton config={VerticalDivider} isComponent></Skeleton>
                </div>
                <div className="flex-column">
                    <Skeleton config={ImagesCarouselConfig} isComponent></Skeleton>
                    <Skeleton config={ButtonConfig} isComponent></Skeleton>
                    <Skeleton config={SeparatorConfig} isComponent></Skeleton>
                    <Skeleton config={LowEmphasisUpsellConfig} isComponent></Skeleton>
                </div>
            </div>
        </div>
    )
}

export default PrescriptionSkeleton
